module.exports = __webpack_public_path__ + "static/media/kanmoshi_logo_small.6877c6d3.png";